module.exports = __webpack_public_path__ + "img/sent-mail.364e2a66.gif";